// Copyright (c) 2022 by Move Closer

import { ContentSneakPeakData, FilterParamConfig, IRelatedService, ModuleContentResolver } from '../../contexts'
import { logger } from '../../support'

import { resolveArticles, resolveFilters } from '../resolvers'

import { ArticlesListModuleContent, ArticlesListModuleContentInput } from './ArticlesList.contracts'

/**
 * @author Maciej Perzankowski <maciej.perzankowski@movecloser.pl>
 */
export const resolveArticlesListModuleContent: ModuleContentResolver<ArticlesListModuleContentInput, ArticlesListModuleContent> =
  async (input: ArticlesListModuleContentInput, relatedService: IRelatedService): Promise<ArticlesListModuleContent> => {
    let articles: ContentSneakPeakData[] = []
    let filters: FilterParamConfig[] | undefined
    let totalItems: number = 0

    try {
      articles = await resolveArticles(input.articles, relatedService)
      filters = input.filters ? await resolveFilters(input.filters, relatedService) : undefined
      const { totalItems: total } = await relatedService.describe(input.articles)
      totalItems = total
    } catch (e) {
      logger(e, 'warn')
    }

    return {
      ...input,
      totalItems,
      articles,
      filters
    }
  }

export const getPaginationConfig = (path: string, rowCount: number, ARTICLES_AMOUNT = 0, ARTICLES_AMOUNT_PER_ROW = 3, query = {}) => {
  const totalPages = Math.ceil((ARTICLES_AMOUNT) / (rowCount * ARTICLES_AMOUNT_PER_ROW))
  const totalVisible = 5

  return {
    showDirectionButtons: true,
    totalPages,
    totalVisible,
    link: { target: { path, query }, param: 'page' }
  }
}
